interface ApiResponse {
  content: string;
}
const baseApiUrl = process.env.REACT_APP_API_URL ?? "";
const apiUrl = `${baseApiUrl}/api/compare`;

export const compareMetadatasheets = async (
  module: File,
  func_name: string,
  var_name: string,
  data_sheet: File,
): Promise<ApiResponse> => {
  try {
    const formData = new FormData();
    formData.append("module", module);
    formData.append("data", data_sheet);

    const queryString = new URLSearchParams({
      func_name: func_name,
      var_name: var_name,
    }).toString();
    const fullUrl = `${apiUrl}?${queryString}`;

    const res = await fetch(fullUrl, {
      method: "POST",
      body: formData,
    });

    if (!res.ok) {
      throw new Error(`Error: ${res.statusText}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error comparing metadata sheets:", error);
    throw error;
  }
};
